import { render, staticRenderFns } from "./TopContentText.vue?vue&type=template&id=6b25365b&scoped=true&"
import script from "./TopContentText.vue?vue&type=script&lang=ts&"
export * from "./TopContentText.vue?vue&type=script&lang=ts&"
import style0 from "./TopContentText.vue?vue&type=style&index=0&id=6b25365b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b25365b",
  null
  
)

export default component.exports